import { render } from "./AccountRecovery.vue?vue&type=template&id=1c795a80"
import script from "./AccountRecovery.vue?vue&type=script&lang=js"
export * from "./AccountRecovery.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__